import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { WhatsAppIcon } from "./icons";
import { WHATSAPP_URL } from "../data/site";

export const FloatingWhatsApp = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Falar com a AMB no WhatsApp"
          data-testid="floating-whatsapp-button"
          initial={{ opacity: 0, y: 24, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.8 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="group fixed bottom-6 right-6 z-40 flex items-center gap-3 lg:bottom-8 lg:right-8"
        >
          <span
            data-testid="floating-whatsapp-label"
            className="pointer-events-none hidden translate-x-2 rounded-full border border-white/10 bg-[#0B0F14]/90 px-4 py-2 text-xs font-medium text-slate-200 opacity-0 backdrop-blur-md transition-[opacity,transform] duration-300 group-hover:translate-x-0 group-hover:opacity-100 sm:block"
          >
            Fale com a AMB agora
          </span>
          <span className="relative flex h-14 w-14 items-center justify-center">
            <span className="wa-pulse absolute inset-0 rounded-full bg-[#25D366]/40" />
            <span className="wa-pulse absolute inset-0 rounded-full bg-[#25D366]/25 [animation-delay:0.9s]" />
            <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.45)] transition-transform duration-300 group-hover:scale-110">
              <WhatsAppIcon className="h-7 w-7" />
            </span>
          </span>
        </motion.a>
      )}
    </AnimatePresence>
  );
};
